import { useEffect } from 'react'
import { useAuthStore } from '@/stores/authStore'
import { useNotificationsStore } from '@/stores/notificationsStore'
import { useNotificationRealtime } from '@/realtime/useNotificationRealtime'
import { NotificationToastStack } from './NotificationToastStack'

export function AuthenticatedNotificationsLayer() {
  const userId = useAuthStore((state) =>
    state.isAuthenticated ? (state.user?.id ?? null) : null,
  )
  const bootstrap = useNotificationsStore((state) => state.bootstrap)
  const reset = useNotificationsStore((state) => state.reset)

  useNotificationRealtime(userId)

  useEffect(() => {
    if (!userId) {
      reset()
      return
    }
    void bootstrap()
  }, [bootstrap, reset, userId])

  return userId ? <NotificationToastStack /> : null
}
